module.exports = __webpack_public_path__ + "static/img/nav_fix.089d6b75.png";